<script>
export default {
  props: ['icon', 'title'],
};
</script>

<template>
  <div class="item">
    <i class="icon" :class="icon" />

    <div class="value-container">
      <div class="item-title">{{ title }}</div>

      <div class="value">
        <slot name="value" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.item {
  display: flex;
  align-items: center;
  gap: 8px;

  .icon {
    width: 28px;
    height: 28px;
    border: 2px solid colors.$dark-beige-color;
    color: colors.$dark-beige-color;
    border-radius: 1000px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    &:before {
      margin: 0;
      padding: 4px;
    }
  }

  .value-container {
    width: 100%;

    .item-title {
      font-size: 10px;
      width: 100%;
    }

    .value {
      font-size: 12px;
      font-weight: 600;
      color: colors.$dark-color;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
